import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { store } from 'react-notifications-component';
import {
  InputText,
  InputTextType
} from '../../../../../shared/components/core-ui/input-text/input-text.component';
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormElementData } from '../../../../../shared/interfaces/form-element-data.interface';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import { UNIT_TYPE_BEDS } from '../../../../../shared/config/cm-unit-type-beds.config';
import { UnitTypeGroupUiModel } from '../../../../../shared/ui-models/unit-type-group.ui-model';
import { Select as MiSelect, MenuItem, FormControl } from '@material-ui/core';
import Select, { ValueType } from 'react-select';
import { UnitTypeBedsUiModel } from '../../../../../shared/ui-models/unit-type-beds.ui-model';

export interface EditGeneralInfoProps {
  data: {
    unitType: UnitTypeUiModel | undefined;
    unitTypeGroupsList: UnitTypeGroupUiModel[];
    unitTypeViewsList: {
      id?: string;
      name: string;
    }[];
    typeOfUnitList: {
      id?: string;
      name: string;
    }[];
    buildingList: any[];
  };

  eventHandlers: {
    submitHandler: (data: Partial<UnitTypeUiModel>) => void;
  };
}

const EditGeneralInfo: React.FC<EditGeneralInfoProps> = ({ data, eventHandlers }) => {
  const [newUnitMeters, setNewUnitMeters] = useState<FormElementData<string>>({
    value: '',
    isValid: false,
    changed: false
  });
  const [newFloorNumber, setNewFloorNumber] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newFurnishingType, setNewFurnishingType] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newAccount, setNewAccount] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newMaxGuests, setNewMaxGuests] = useState<FormElementData<number>>({
    value: 0,
    isValid: false,
    changed: false
  });
  const [newBedroomsNumber, setNewBedroomsNumber] = useState<FormElementData<number>>({
    value: 0,
    isValid: false,
    changed: false
  });

  const [newBathroomNumber, setNewBathroomsNumber] = useState<FormElementData<number>>({
    value: 0,
    isValid: false,
    changed: false
  });

  const [newViewLink, setNewViewLink] = useState<FormElementData<string>>({
    value: '',
    isValid: false,
    changed: false
  });

  const [newHouseRules, setNewHouseRules] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newOnboardingMessage, setNewOnboardingMessage] = useState<
    FormElementData<string | undefined>
  >({
    value: undefined,
    isValid: false,
    changed: false
  });

  const [newDescription, setNewDescription] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newWebSiteDescription, setNewWebSiteDescription] = useState<
    FormElementData<string | undefined>
  >({
    value: undefined,
    isValid: false,
    changed: false
  });

  const [newName, setNewName] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newUnitTypeGroup, setNewUnitTypeGroup] = useState<FormElementData<string>>({
    value: '',
    isValid: false,
    changed: false
  });
  const [newTypeOfUnit, setNewTypeOfUnit] = useState<FormElementData<number>>({
    value: 0,
    isValid: false,
    changed: false
  });
  const [newView, setNewView] = useState<FormElementData<number>>({
    value: 0,
    isValid: false,
    changed: false
  });
  const [newBuilding, setNewBuilding] = useState<FormElementData<string>>({
    value: '',
    isValid: false,
    changed: false
  });
  const [newBeds, setNewBeds] = useState<UnitTypeBedsUiModel[]>([]);
  const [newBedsChanged, setNewBedsChanged] = useState<boolean>(false);

  const { t } = useTranslation();
  const isMobileView = useWindowResizer();

  useEffect(() => {
    setNewUnitMeters({
      value: data.unitType?.unitMeters || '',
      isValid: false,
      changed: false
    });
    setNewFloorNumber({
      value: data.unitType?.floor ? String(data.unitType.floor) : undefined,
      isValid: false,
      changed: false
    });
    setNewFurnishingType({
      value: data.unitType?.furnishingType || undefined,
      isValid: false,
      changed: false
    });
    setNewAccount({
      value: data.unitType?.account || undefined,
      isValid: false,
      changed: false
    });
    setNewBedroomsNumber({
      value: data.unitType?.bedrooms || 0,
      isValid: false,
      changed: false
    });
    if (data.unitType?.beds) {
      setNewBeds(data.unitType?.beds);
    } else {
      const newBedsArr: UnitTypeBedsUiModel[] = [];
      for (
        let i = 0;
        i < (data && data.unitType && data.unitType.bedrooms ? data.unitType.bedrooms : 0);
        i++
      ) {
        newBedsArr[i] = {
          roomName: `Bedroom ${i + 1}`,
          bedsCount: []
        };
      }
      setNewBeds(newBedsArr);
    }
    setNewBathroomsNumber({
      value: data.unitType?.bathrooms || 0,
      isValid: false,
      changed: false
    });
    setNewViewLink({
      value: data.unitType?.viewLink || '',
      isValid: false,
      changed: false
    });
    setNewMaxGuests({
      value: data.unitType?.maxGuests || 0,
      isValid: false,
      changed: false
    });
    setNewName({
      value: data.unitType?.name || '',
      isValid: false,
      changed: false
    });
    setNewUnitTypeGroup({
      value: data.unitType?.unitTypeGroupId || '',
      isValid: false,
      changed: false
    });
    setNewTypeOfUnit({
      value: data.unitType?.typeOfUnit || 0,
      isValid: false,
      changed: false
    });
    setNewView({
      value: data.unitType?.view || 0,
      isValid: false,
      changed: false
    });
    setNewBuilding({
      value: data.unitType?.buildingId ? String(data.unitType.buildingId) : '',
      isValid: false,
      changed: false
    });
    if (data.unitType) {
      setNewDescription({
        value: data.unitType.description || '',
        isValid: false,
        changed: false
      });
      setNewWebSiteDescription({
        value: data.unitType.websiteDescription || '',
        isValid: false,
        changed: false
      });
      setNewHouseRules({
        value: data.unitType.houseRules || '',
        isValid: false,
        changed: false
      });
      setNewOnboardingMessage({
        value: data.unitType.onboardingMessage || '',
        isValid: false,
        changed: false
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.unitType]);

  const handleGeneralInfoSubmit = () => {
    const updatedData: Partial<UnitTypeUiModel> = {};
    if (newUnitMeters.changed && newUnitMeters.value) {
      updatedData['unitMeters'] = newUnitMeters.value;
    }
    if (newBedroomsNumber.changed && newBedroomsNumber.value) {
      updatedData['bedrooms'] = newBedroomsNumber.value;
    }
    if (newBedsChanged) {
      updatedData['beds'] = newBeds;
    }
    if (newBathroomNumber.changed && newBathroomNumber.value) {
      updatedData['bathrooms'] = newBathroomNumber.value;
    }
    if (newFloorNumber.changed && newFloorNumber.value) {
      updatedData['floor'] = newFloorNumber.value;
    }
    if (newFurnishingType.changed && newFurnishingType.value) {
      updatedData['furnishingType'] = newFurnishingType.value;
    }
    if (newAccount.changed && newAccount.value) {
      updatedData['account'] = newAccount.value;
    }
    if (newHouseRules.changed && newHouseRules.value) {
      updatedData['houseRules'] = newHouseRules.value;
    }
    if (newOnboardingMessage.changed && newOnboardingMessage.value) {
      updatedData['onboardingMessage'] = newOnboardingMessage.value;
    }
    if (newViewLink.changed && newViewLink.value) {
      updatedData['viewLink'] = newViewLink.value;
    }
    if (newName.changed && newName.value) {
      updatedData['name'] = newName.value;
    }
    if (newDescription.changed && newDescription.value) {
      updatedData['description'] = newDescription.value;
    }
    if (newMaxGuests.changed && newMaxGuests.value) {
      updatedData['maxGuests'] = newMaxGuests.value;
    }
    if (newUnitTypeGroup.changed && newUnitTypeGroup.value) {
      updatedData['unitTypeGroupId'] = newUnitTypeGroup.value;
    }
    if (newTypeOfUnit.changed && newTypeOfUnit.value) {
      updatedData['typeOfUnit'] = newTypeOfUnit.value;
    }
    if (newView.changed && newView.value) {
      updatedData['view'] = newView.value;
    }
    if (newBuilding.changed) {
      updatedData['buildingId'] = newBuilding.value || '';
    }

    if (newWebSiteDescription.changed && newWebSiteDescription.value) {
      updatedData['websiteDescription'] = newWebSiteDescription.value;
    }
    eventHandlers.submitHandler(updatedData);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm bg-gradient-to-b from-primary-50/60 to-white mt-4 p-6 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Unit Type Name - Full Width */}
        <div className="col-span-1 md:col-span-2">
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.UNIT_TYPE_NAME')}
          </label>
          <div className="my-4">
            <InputText
              config={{
                autoFocus: false,
                type: InputTextType.text,
                required: true,
                disabled: false
              }}
              data={{
                placeholder: t(
                  'UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.UNIT_TYPE_NAME_PLACEHOLDER'
                ),
                errorMessage: t(
                  'AUTH_MODULE.RESET_PASSWORD_CONTAINER.UNIT_TYPE_NAME_ERROR_MESSAGE'
                ),
                value: newName.value || ''
              }}
              eventHandlers={{
                onChangeHandler: (value, isValid) => {
                  if (isValid) {
                    setNewName({
                      value,
                      isValid: true,
                      changed: true
                    });
                  }
                }
              }}
            />
          </div>
        </div>

        {/* Website Description - Full Width */}
        {newWebSiteDescription.value !== undefined && (
          <div className="col-span-1 md:col-span-2">
            <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
              {t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.UNIT_TYPE_WEBSITE_DESCRIPTION')}
            </label>
            <div className="my-4">
              <CKEditor
                editor={ClassicEditor}
                data={newWebSiteDescription?.value}
                onChange={(_event: any, editor: any) => {
                  const newData: string = editor.getData();
                  setNewWebSiteDescription({ value: newData, isValid: true, changed: true });
                }}
              />
            </div>
          </div>
        )}

        {/* Description - Full Width */}
        {newDescription.value !== undefined && (
          <div className="col-span-1 md:col-span-2">
            <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
              {t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.UNIT_TYPE_DESCRIPTION')}
            </label>
            <div className="my-4">
              <CKEditor
                editor={ClassicEditor}
                data={newDescription.value}
                onChange={(event: any, editor: any) => {
                  const newData: string = editor.getData();
                  setNewDescription({ value: newData, isValid: true, changed: true });
                }}
              />
            </div>
          </div>
        )}

        {/* House Rules - Full Width */}
        {newHouseRules.value !== undefined && (
          <div className="col-span-1 md:col-span-2">
            <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
              {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.HOUSE_RULES')}
            </label>
            <div className="my-4">
              <CKEditor
                editor={ClassicEditor}
                data={newHouseRules.value}
                onChange={(event: any, editor: any) => {
                  const newData: string = editor.getData();
                  setNewHouseRules({ value: newData, isValid: true, changed: true });
                }}
              />
            </div>
          </div>
        )}

        {/* Onboarding Message - Full Width */}
        {newOnboardingMessage.value !== undefined && (
          <div className="col-span-1 md:col-span-2">
            <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
              {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.ONBOARDING')}
            </label>
            <div className="my-4">
              <CKEditor
                editor={ClassicEditor}
                data={newOnboardingMessage.value}
                onChange={(event: any, editor: any) => {
                  const newData: string = editor.getData();
                  setNewOnboardingMessage({ value: newData, isValid: true, changed: true });
                }}
              />
            </div>
          </div>
        )}

        {/* Number of Guests */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NUMBER_OF_GUESTS')}
          </label>
          <div className="my-4">
            <InputText
              config={{
                autoFocus: false,
                type: InputTextType.number
              }}
              data={{
                placeholder: t(
                  'UNIT_TYPE_MODULE.EDIT_UNIT_TYPE_CONTAINER.NUMBER_OF_GUESTS_PLACEHOLDER'
                ),
                errorMessage: t(
                  'AUTH_MODULE.RESET_PASSWORD_CONTAINER.UNIT_TYPE_NAME_ERROR_MESSAGE'
                ),
                value: newMaxGuests.value || 0
              }}
              eventHandlers={{
                onChangeHandler: (value, isValid) => {
                  if (isValid) {
                    setNewMaxGuests({
                      value: Number(value),
                      isValid: true,
                      changed: true
                    });
                  }
                }
              }}
            />
          </div>
        </div>
        {/* Unit Meters */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.UNIT_METERS')}
          </label>
          <div className="my-4">
            <InputText
              config={{
                autoFocus: false,
                type: InputTextType.text
              }}
              data={{
                placeholder: t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.UNIT_METERS_PLACEHOLDER'),
                value: newUnitMeters.value
              }}
              eventHandlers={{
                onChangeHandler: (value, isValid) => {
                  if (isValid) {
                    setNewUnitMeters({
                      value,
                      isValid: true,
                      changed: true
                    });
                  }
                }
              }}
            />
          </div>
        </div>
        {/* Accommodation Type */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            Accommodation Type
          </label>
          <div className="my-4">
            <FormControl variant="outlined" fullWidth>
              <MiSelect
                labelId="accommodation-type-label"
                id="accommodation-type"
                value={newUnitTypeGroup.value}
                onChange={(
                  event: React.ChangeEvent<{
                    name?: string | undefined;
                    value: unknown;
                  }>
                ) => {
                  setNewUnitTypeGroup({
                    value: event.target.value as string,
                    isValid: true,
                    changed: true
                  });
                }}
              >
                {data.unitTypeGroupsList.map((unitGroup, index) => (
                  <MenuItem value={unitGroup.id} key={index}>
                    {unitGroup.name}
                  </MenuItem>
                ))}
              </MiSelect>
            </FormControl>
          </div>
        </div>

        {/* Type Of Unit */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            Type Of Unit
          </label>
          <div className="my-4">
            <FormControl variant="outlined" fullWidth>
              <MiSelect
                labelId="type-of-unit-label"
                id="type-of-unit"
                value={newTypeOfUnit.value}
                onChange={(
                  event: React.ChangeEvent<{
                    name?: string | undefined;
                    value: unknown;
                  }>
                ) => {
                  setNewTypeOfUnit({
                    value: event.target.value as unknown as number,
                    isValid: true,
                    changed: true
                  });
                }}
              >
                {data.typeOfUnitList.map((typeOfUnit, index) => (
                  <MenuItem value={typeOfUnit.id} key={index}>
                    {typeOfUnit.name}
                  </MenuItem>
                ))}
              </MiSelect>
            </FormControl>
          </div>
        </div>

        {/* Building Name */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            Building Name
          </label>
          <div className="my-4">
            <FormControl variant="outlined" fullWidth>
              <MiSelect
                labelId="building-select-label"
                id="building-select"
                value={newBuilding.value}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return 'Select building';
                  }
                  const selectedBuilding = data.buildingList?.find((building) => {
                    const buildingIdValue = building?.id ? String(building.id) : '';
                    return buildingIdValue === String(selected);
                  });
                  return selectedBuilding?.name || selected;
                }}
                onChange={(
                  event: React.ChangeEvent<{
                    name?: string | undefined;
                    value: unknown;
                  }>
                ) => {
                  setNewBuilding({
                    value: String(event.target.value || ''),
                    isValid: true,
                    changed: true
                  });
                }}
              >
                <MenuItem value="" disabled>
                  Select building
                </MenuItem>
                {data.buildingList && data.buildingList.length > 0 ? (
                  data.buildingList.map((building, index) => (
                    <MenuItem value={String(building.id)} key={building.id || index}>
                      {building.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No buildings available
                  </MenuItem>
                )}
              </MiSelect>
            </FormControl>
          </div>
        </div>

        {/* View */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            View
          </label>
          <div className="my-4">
            <FormControl variant="outlined" fullWidth>
              <MiSelect
                labelId="view-label"
                id="view-select"
                value={newView.value}
                onChange={(
                  event: React.ChangeEvent<{
                    name?: string | undefined;
                    value: unknown;
                  }>
                ) => {
                  setNewView({
                    value: event.target.value as unknown as number,
                    isValid: true,
                    changed: true
                  });
                }}
              >
                {data.unitTypeViewsList.map((view, index) => (
                  <MenuItem value={view.id} key={index}>
                    {view.name}
                  </MenuItem>
                ))}
              </MiSelect>
            </FormControl>
          </div>
        </div>

        {/* Floor Number */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.FLOOR_NUMBER')}
          </label>
          <div className="my-4">
            <Select
              options={[
                { value: 'Ground Floor', label: 'Ground Floor' },
                ...Array.from({ length: 50 }, (_, index) => {
                  const floor = String(index + 1);
                  return { value: floor, label: floor };
                })
              ]}
              value={
                newFloorNumber.value
                  ? { value: newFloorNumber.value, label: newFloorNumber.value }
                  : null
              }
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                if (value && 'value' in value) {
                  setNewFloorNumber({
                    value: value.value,
                    isValid: true,
                    changed: true
                  });
                }
              }}
            />
          </div>
        </div>

        {/* Furnishing Type */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            Furnishing Type
          </label>
          <div className="my-4">
            <Select
              options={[
                { value: 'Birdnest furnished', label: 'Birdnest furnished' },
                { value: 'High quality', label: 'High quality' },
                { value: 'Standard', label: 'Standard' }
              ]}
              value={
                newFurnishingType.value
                  ? { value: newFurnishingType.value, label: newFurnishingType.value }
                  : null
              }
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                if (value && 'value' in value) {
                  setNewFurnishingType({
                    value: value.value,
                    isValid: true,
                    changed: true
                  });
                }
              }}
            />
          </div>
        </div>

        {/* Account */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            Account
          </label>
          <div className="my-4">
            <Select
              options={[
                { value: 'Egypt', label: 'Egypt' },
                { value: 'UAE', label: 'UAE' }
              ]}
              value={newAccount.value ? { value: newAccount.value, label: newAccount.value } : null}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                if (value && 'value' in value) {
                  setNewAccount({
                    value: value.value,
                    isValid: true,
                    changed: true
                  });
                }
              }}
            />
          </div>
        </div>

        {/* Bedrooms Numbers */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.BEDROOMS_NUMBERS')}
          </label>
          <div className="my-4">
            <InputText
              config={{
                autoFocus: false,
                type: InputTextType.number
              }}
              data={{
                placeholder: t(
                  'UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.SECURITY_DEPOSIT_PLACEHOLDER'
                ),
                value: newBedroomsNumber.value
              }}
              eventHandlers={{
                onChangeHandler: (value, isValid) => {
                  if (isValid) {
                    setNewBedroomsNumber({
                      value: Number(value),
                      isValid: true,
                      changed: true
                    });
                    const newBedsArr: UnitTypeBedsUiModel[] = [];
                    for (let i = 0; i < Number(value); i++) {
                      if (i < newBeds.length) {
                        newBedsArr[i] = { ...newBeds[i] };
                      } else {
                        newBedsArr[i] = {
                          roomName: `Bedroom ${i + 1}`,
                          bedsCount: []
                        };
                      }
                    }
                    setNewBeds(newBedsArr);
                    setNewBedsChanged(true);
                  }
                }
              }}
            />
          </div>
        </div>

        {/* Bathrooms Numbers */}
        <div>
          <label className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
            {t('UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.BATHROOMS_NUMBERS')}
          </label>
          <div className="my-4">
            <InputText
              config={{
                autoFocus: false,
                type: InputTextType.number
              }}
              data={{
                placeholder: t(
                  'UNIT_TYPE_MODULE.EDIT_GENERAL_CONTAINER.SECURITY_DEPOSIT_PLACEHOLDER'
                ),
                value: newBathroomNumber.value
              }}
              eventHandlers={{
                onChangeHandler: (value, isValid) => {
                  if (isValid) {
                    setNewBathroomsNumber({
                      value: Number(value),
                      isValid: true,
                      changed: true
                    });
                  }
                }
              }}
            />
          </div>
        </div>

        {/* Beds in Rooms - Full Width */}
        {newBedroomsNumber.value > 0 && (
          <div className="col-span-1 md:col-span-2">
            <b className="block text-xl font-medium text-neutral-500 font-gilroy-medium mb-2">
              Beds in Rooms
            </b>
            <div className="bg-gray-100 p-6 rounded-lg mb-6 flex flex-col relative">
              {newBeds &&
                newBeds.map((roomsBed, index) => (
                  <div
                    key={index}
                    className="border-2 border-dashed border-gray-400 p-4 mb-4 rounded-lg"
                  >
                    {roomsBed.roomName}
                    <div className="flex justify-start flex-wrap">
                      {newBeds[index].bedsCount.length === 0 ? (
                        <p className="text-red-600 text-center w-full">
                          No Beds selected for this room yet!
                        </p>
                      ) : (
                        newBeds[index].bedsCount.map((item, innerIndex) => {
                          const foundItem = UNIT_TYPE_BEDS.find((bed) => bed.value === item.id);
                          const elementToRender = [];
                          for (let i = 0; i < item.count; i++) {
                            elementToRender.push(
                              <div
                                key={`${index}-${innerIndex}-${i}`}
                                className="inline-flex items-center gap-1 bg-primary-400 text-white px-3 py-1 rounded-full text-lg font-medium m-1 border border-blue-300 hover:bg-blue-200 transition-colors"
                              >
                                <span>{foundItem?.label}</span>
                                <button
                                  type="button"
                                  onClick={() => {
                                    const updatedNewBeds = [...newBeds];
                                    if (updatedNewBeds[index].bedsCount[innerIndex].count > 1) {
                                      updatedNewBeds[index].bedsCount[innerIndex].count =
                                        updatedNewBeds[index].bedsCount[innerIndex].count - 1;
                                    } else {
                                      updatedNewBeds[index].bedsCount.splice(innerIndex, 1);
                                    }
                                    setNewBeds(updatedNewBeds);
                                    setNewBedsChanged(true);
                                  }}
                                  className="text-white font-bold text-lg leading-none ml-1"
                                  aria-label="Remove"
                                >
                                  ×
                                </button>
                              </div>
                            );
                          }
                          return elementToRender;
                        })
                      )}
                    </div>

                    <Select
                      hideSelectedOptions={false}
                      options={UNIT_TYPE_BEDS}
                      onChange={(
                        value: ValueType<{ value: string | undefined; label: string }, false>
                      ) => {
                        if (value && 'value' in value && value.value) {
                          const updatedNewBeds = [...newBeds];
                          const foundBedCountIndex = updatedNewBeds[index].bedsCount.findIndex(
                            (item) => value.value === item.id
                          );
                          if (foundBedCountIndex > -1) {
                            const updatedBedsCount = [...updatedNewBeds[index].bedsCount];
                            updatedBedsCount[foundBedCountIndex].count =
                              updatedBedsCount[foundBedCountIndex].count + 1;
                            updatedNewBeds[index].bedsCount = updatedBedsCount;
                          } else {
                            updatedNewBeds[index] = {
                              ...updatedNewBeds[index],
                              bedsCount: [
                                ...updatedNewBeds[index].bedsCount,
                                {
                                  id: value.value,
                                  count: 1
                                }
                              ]
                            };
                          }
                          setNewBeds(updatedNewBeds);
                          setNewBedsChanged(true);
                        }
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg rounded-b-lg z-6 flex flex-row justify-end gap-3">
        <Button
          disabled={
            (newBedroomsNumber.value === 0 || !newBedroomsNumber.changed) &&
            (newUnitMeters.value === '' || !newUnitMeters.changed) &&
            (newBathroomNumber.value === 0 || !newBathroomNumber.changed) &&
            (newHouseRules.value === '' || !newHouseRules.changed) &&
            (newOnboardingMessage.value === '' || !newOnboardingMessage.changed) &&
            (newViewLink.value === '' || !newViewLink.changed) &&
            (newName.value === '' || !newName.changed) &&
            (newDescription.value === '' || !newDescription.changed) &&
            (newMaxGuests.value === 0 || !newMaxGuests.changed) &&
            (newUnitTypeGroup.value === '' || !newUnitTypeGroup.changed) &&
            !newBedsChanged &&
            (newWebSiteDescription.value === '' || !newWebSiteDescription.changed) &&
            !newFloorNumber.changed &&
            !newView.changed &&
            (newBuilding.value === '' || !newBuilding.changed) &&
            !newTypeOfUnit.changed &&
            !newFurnishingType.changed &&
            !newAccount.changed
          }
          onClick={handleGeneralInfoSubmit}
          tracking={{
            event: 'record_saved',
            entity: 'unit_type',
            action: 'update',
            outcome: 'success'
          }}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          Update
        </Button>
      </div>
    </div>
  );
};

export default EditGeneralInfo;
